<div class="industry-item" [class.editing]="isEditing">
  <!-- Normal View -->
  <div class="industry-content" *ngIf="!isEditing"
       fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="12px">

    <mat-slide-toggle
      [(ngModel)]="industry.selected"
      (ngModelChange)="onSelectionChange()"
      color="primary">
    </mat-slide-toggle>

    <div fxFlex class="industry-info">
      <h4 class="industry-title">{{displayName}}</h4>
      <p *ngIf="displayDescription" class="industry-description">{{displayDescription}}</p>

      <!-- Show original values as hints when overrides exist -->
      <div *ngIf="isMasterIndustry && industry.name && industry.labelNameOverride"
           class="original-hint">
        Original: {{industry.name}}
      </div>
      <div *ngIf="isMasterIndustry && industry.description && industry.labelDescriptionOverride"
           class="original-hint">
        Original: {{industry.description}}
      </div>
    </div>

    <button mat-icon-button (click)="startEditing()" class="edit-button">
      <mat-icon>edit</mat-icon>
    </button>
  </div>

  <!-- Edit Form -->
  <div class="edit-form" *ngIf="isEditing" [formGroup]="editForm" fxLayout="column" fxLayoutGap="32px">
    <mat-form-field class="custom-text-field full-width-i" appearance="outline" floatLabel="always">
      <mat-label>Custom label</mat-label>
      <input matInput  formControlName="labelName" [placeholder]="displayName">
      <mat-icon matSuffix class="btn-cursor reset-icon" (click)="resetLabelNameToDefault()"
                matTooltip="Reset to default">
        refresh
      </mat-icon>
      <mat-hint *ngIf="isMasterIndustry && industry.name">Original: {{industry.name}}</mat-hint>
      <mat-error *ngIf="editForm.get('labelName')?.hasError('maxlength')">
        Label name cannot exceed 100 characters
      </mat-error>
    </mat-form-field>

    <mat-form-field class="custom-text-field full-width-i" appearance="outline" floatLabel="always">
      <mat-label>Custom description</mat-label>
      <input matInput formControlName="labelDescription" [placeholder]="displayDescription">
      <mat-icon matSuffix class="btn-cursor reset-icon" (click)="resetLabelDescriptionToDefault()"
                matTooltip="Reset to default">
        refresh
      </mat-icon>
      <mat-hint *ngIf="isMasterIndustry && industry.description">Original: {{industry.description}}</mat-hint>
      <mat-error *ngIf="editForm.get('labelDescription')?.hasError('maxlength')">
        Description cannot exceed 500 characters
      </mat-error>
    </mat-form-field>

    <div fxLayout="row" fxLayoutGap="8px" fxLayoutAlign="end center" class="full-width">
      <button class="button-action-cancel" mat-flat-button (click)="cancelEditing()" [disabled]="!canCancel">
        <div class="button-text">Cancel</div>
      </button>
      <button class="button-action" mat-flat-button color="primary" (click)="saveEditing()" [disabled]="!canSave">
        <div class="button-text">Save</div>
      </button>
    </div>
  </div>
</div>
